import HelperInterface from "../Interfaces/HelperInterface";

export default class Fauci implements HelperInterface
{
    el: HTMLElement;
    msg: HTMLElement;

    constructor()
    {
        this.el = document.createElement('div');
        this.el.id = 'FauciContainer';

        let fauci = document.createElement('div');
        fauci.id = 'Fauci';
        this.el.appendChild(fauci);

        this.msg = document.createElement('div');
        this.msg.classList.add('HelperMessage');
        this.el.appendChild(this.msg);
    }

    render()
    {
        return this.el;
    }

    say(message: string): void
    {
        this.msg.innerHTML = message;
    }

    hide(): void
    {
        this.el.style.height = '0px';
    }

    show(): void
    {
        this.el.style.height = '148px';
    }
}